import { Route, Switch } from "react-router-dom"
import CardLog from "./log-card/card-log.jsx"
import AccountLog from "./logs-account/account-log.jsx"
const Logs = () => {
    return (
        <Switch>
            <Route path="/logs/card" component={CardLog}></Route>
            <Route path="/logs/account" component={AccountLog}></Route>
        </Switch>
    )
}
export default Logs